import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import QuillButton from '@Common/quillElements/button/QuillButton';
import { Fade, Theme } from '@quillbot/design-system';
import { useSelector } from 'react-redux';
import { RootState } from 'src/_common/models/redux/store';
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) => ({
  btn: {
    overflow: 'hidden',
  },
  loader: {
    color: 'white',
    position: 'absolute',
    padding: '9px',
  },
  fadeIn: {
    animation: '$fadeIn 1000ms',
    animationFillMode: 'forwards',
  },
  '@keyframes fadeIn': {
    from: {
      opacity: '0',
    },
    to: {
      opacity: '1',
    },
  },
  slideUp: {
    animation: '$slideUp  600ms',
    animationFillMode: 'forwards',
  },
  '@keyframes slideUp': {
    from: {
      opacity: '1',
    },
    to: {
      opacity: '0',
      transform: 'translate3d(0, -100%, 0)',
    },
  },
  hidden: {
    display: 'none',
  },

  spinningLoader: {
    width: '20px',
    height: '20px',
    border: `2px solid ${theme.palette.primary.main}`,
    'border-left-color': 'white',
    'border-top-color': 'white',
    'border-radius': '50%',
    background: 'transparent',
    'animation-name': '$rotate-s-loader',
    'animation-iteration-count': 'infinite',
    'animation-duration': '0.8s',
    'animation-timing-function': 'linear',
    position: 'absolute',
  },
  '@keyframes rotate-s-loader': {
    from: {
      transform: 'rotate(0)',
    },
    to: {
      transform: 'rotate(360deg)',
    },
  },
}));
interface IProps {
  className: string;
  style: any;
  color: any;
  variant: any;
  buttonText: string;
  // firstParaphrase?: any;
  disabled: any;
  onMouseEnter?: any | null;
  onMouseDown?: any | null;
  onClick: Function;
}
function NewQuillBtn(props: IProps) {
  const classes = useStyles();
  const [showBtnAnimation, setshowBtnAnimation] = useState(false);
  const isTextVisible = !props.disabled;
  const startedQuilling = props.disabled;
  const isIE = useSelector((rootState: RootState) => rootState?.common?.platform?.isIE);
  useEffect(() => {
    if (startedQuilling === true) {
      setshowBtnAnimation(true);
    }
  }, [props.disabled]);
  return (
    <>
      <QuillButton
        className={`${props.className} ${classes.btn}`}
        style={props.style}
        color={props.color}
        variant={props.variant}
        disabled={props.disabled}
        disableRipple
        onMouseEnter={props.onMouseEnter ? props.onMouseEnter : null}
        onMouseDown={props.onMouseDown ? props.onMouseDown : null}
        onClick={() => {
          props.onClick();
          if (startedQuilling === true) {
            setshowBtnAnimation(true);
          }
        }}
      >
        {!isIE && (
          <>
            <div
              className={`${
                showBtnAnimation && (isTextVisible ? classes.fadeIn : classes.slideUp)
              }`}
            >
              {props.buttonText}
            </div>
            {showBtnAnimation && (
              <Fade in={!isTextVisible} timeout={1100}>
                <div
                  className={clsx(`${isTextVisible ? classes.hidden : classes.spinningLoader}`)}
                />
              </Fade>
            )}
          </>
        )}
        {isIE && (
          <>
            {startedQuilling ? (
              <div
                style={{ position: 'inherit', width: '20px', height: '20px' }}
                className={clsx(`${isTextVisible ? classes.hidden : classes.spinningLoader}`)}
              />
            ) : (
              props.buttonText
            )}
          </>
        )}
      </QuillButton>
    </>
  );
}
export default NewQuillBtn;
